import React from "react";
import { useLocation } from "react-router-dom";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";

const ProjectUnderConstruction = () => {
  const { pathname } = useLocation();
  const capitalizeFirstLetter = (path) => {
    // Split the path by '/'
    const parts = path?.split("/");

    // Split the third part by '-' and join with space
    const words = parts[2]?.split("-");
    const capitalizedWords = words?.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );

    // Join the capitalized words with spaces
    const result = capitalizedWords?.join(" ");

    return result;
  };

  const capitalizedString = capitalizeFirstLetter(pathname);

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title="Sustainable Development"
        titleLink="/sustainable-development/environment"
        levelTwo={true}
        levelThree={false}
        isActive="Under Construction Page"
        titleTwo="Under Construction Page"
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <div className="row mb-5">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mvDescWrap">
                  <div className="title-sec">
                    {/* <h4>About NEEPCO</h4> */}
                    <h4>{capitalizedString} page Coming Soon</h4>
                  </div>
                  <div className="about_inntxt">
                    <p>
                      Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                      Officiis, voluptatem quidem! Sequi, at asperiores
                      voluptate, quo molestias possimus repellat blanditiis,
                      sapiente quis labore corrupti obcaecati quaerat rerum quas
                      minima magnam velit error. Optio laborum cum nemo nam
                      aperiam accusantium dolores maiores, quas sunt adipisci
                      dolorem iusto enim dicta eligendi impedit delectus quos
                      reprehenderit! Culpa debitis rem beatae vitae porro esse
                      sint hic delectus. Tempore consectetur nisi nihil minima
                      nam quo animi illo suscipit. Ex, in harum! Expedita eaque
                      quisquam cupiditate corrupti totam ex soluta aut maiores
                      quaerat vero iste at sed facere porro facilis voluptatibus
                      deleniti, quae omnis, exercitationem iusto ab, recusandae
                      sequi doloremque eligendi. Earum vero qui reprehenderit
                      impedit repudiandae! Odio, fuga provident reprehenderit
                      velit in aliquid dignissimos expedita ut, vel eos eaque,
                      tempore distinctio iste? Molestiae repudiandae quaerat
                      minima amet ab perspiciatis inventore molestias omnis
                      dolorum, quos alias, accusamus, neque fuga quam eaque
                      maxime consequatur! Maiores illum odit officiis aspernatur
                      excepturi alias nam. Voluptate nostrum sunt accusantium
                      maiores laudantium voluptates veritatis odit a, inventore
                      consectetur, libero nesciunt facilis iure dolor quibusdam
                      totam dignissimos tempore laborum sapiente, error ea.
                      Optio rem, distinctio ex, nostrum culpa iusto natus
                      maiores, sapiente quaerat commodi qui. Debitis enim libero
                      excepturi aut optio quas. Impedit nostrum iure quod,
                      quidem voluptate, recusandae itaque quam labore laudantium
                      unde numquam, molestiae nam expedita officiis excepturi.
                      Molestias iure laborum enim dolor aut impedit, minima
                      accusamus consectetur cum in ad quis architecto temporibus
                      voluptatum voluptatem neque dolores corporis quia modi
                      dolorum culpa aliquam sit est quasi. Id nostrum ratione,
                      accusamus hic ab voluptatem repellendus in ducimus! Hic
                      reprehenderit consequuntur optio nulla eius voluptates,
                      quaerat molestias, maxime ut, nisi vel nam dolor eos
                      officiis accusantium inventore veritatis! Iste est
                      dignissimos molestias. Quis expedita animi, cupiditate
                      minus excepturi enim reprehenderit voluptates itaque atque
                      corporis sed iusto, dolore ex molestiae fugit saepe?
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ProjectUnderConstruction;
